import { useState } from "react";
import { Pencil, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { MoodTagEditor, MoodBadge, TagChip } from "./MoodTagEditor";

export const EntryMoodTags = ({ entry, onUpdated }) => {
  const { t } = useI18n();
  const [editing, setEditing] = useState(false);
  const [mood, setMood] = useState(entry.mood);
  const [tags, setTags] = useState(entry.tags);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/entries/${entry.id}`, { mood, tags });
      onUpdated(data);
      setEditing(false);
      toast.success(t("d_updated"));
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  if (editing) {
    return (
      <div className="glass-card p-5 sm:p-6 mt-6 space-y-4 fade-up" data-testid="entry-mood-tags-editor">
        <MoodTagEditor mood={mood} tags={tags} onMood={setMood} onTags={setTags} disabled={busy} />
        <div className="flex gap-3 justify-end">
          <button data-testid="entry-mood-tags-cancel-btn" onClick={() => { setEditing(false); setMood(entry.mood); setTags(entry.tags); }} className="px-4 py-2 rounded-full border border-white/10 text-sm text-[#C2C9DB]">{t("d_cancel")}</button>
          <button data-testid="entry-mood-tags-save-btn" disabled={busy} onClick={save} className="btn-gold px-5 py-2 rounded-full text-sm inline-flex items-center gap-2">
            {busy && <Loader2 size={14} className="animate-spin" />} {t("d_save")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 mt-6" data-testid="entry-mood-tags">
      <MoodBadge mood={entry.mood} testid="entry-detail-mood" />
      {entry.tags.map((tag) => <TagChip key={tag} tag={tag} testid={`entry-detail-tag-${tag}`} />)}
      <button data-testid="entry-mood-tags-edit-btn" onClick={() => setEditing(true)} className="inline-flex items-center gap-1.5 text-xs text-[#8E9BB4] hover:text-[#E5C158] ml-1">
        <Pencil size={12} /> {t("d_edit")}
      </button>
    </div>
  );
};
